import React, { useState } from "react";
import { Box, Typography, Divider, Button } from "@mui/material";
import Modal from "@mui/material/Modal";
import { useDispatch, useSelector } from "react-redux";
import { RiCloseCircleLine } from "react-icons/ri";
import { closeModal, showModal } from "../../store/reducers/modal";
import axios from "axios";
import { closePaymentModal, useFlutterwave } from "flutterwave-react-v3";
import { toast } from "react-toastify";
import { usePaystackPayment } from "react-paystack";
import FormButton from "../../Component/ui/button/FormButton";
import transactionDetails from "../../store/reducers/transactionDetails";
import Spinner from "../../Component/ui/Spinner";
import { API } from "../../pages/backend";
import Swal from "sweetalert2";
import Receipt from "../paymentreceipt";
import { useNavigate } from "react-router-dom";
import ConfirmationReceipt from "../confirmationreceipt";
import { BsFillInfoCircleFill } from "react-icons/bs";

const PaymentModal = () => {
  const navigate = useNavigate();

  const details = useSelector(
    (state) => state.transactionDetails.data?.transactionDetails,
  );

  // console.log(details)
  const [flutterloading, setFlutterLoading] = useState(false);
  const [squadloading, setSquadLoading] = useState(false);
  const [paystackLoading, setPaystackLoading] = useState(false);
  const [codeLoading, setCodeLoading] = useState(false);
  const user = useSelector((state) => state.user.data.details);
  // console.log(user);
  const token = useSelector((state) => state.user.data.token);
  // console.log(token);

  const dispatch = useDispatch();

  // console.log(details.paymentExamType);

  const pay4ItCallbackUrl =
    details?.paymentExamType === "BECE"
      ? `/requisition/bece?tab=payment-details`
      : details?.paymentExamType === "CAS/Placement"
        ? `/requisition/junior?tab=payment-details`
        : details?.paymentExamType === "Public Service"
          ? `/requisition/public?tab=payment-details`
          : details?.paymentExamType === "Trade Test"
            ? `/requisition/tradetest?tab=payment-details`
            : `/requisition/model?tab=payment-details`;

  //  console.log(pay4ItCallbackUrl)
  const beceCodeUrl = `${API}auth/code/bece/`;
  const casCodeUrl = `${API}auth/code/cas/`;

  const examCodeUrl =
    details.paymentExamType === "B.E.C.E" ? beceCodeUrl : casCodeUrl;

  const generateCode = async () => {
    setCodeLoading(true);
    try {
      const body = {
        categoryId: user?.categoryId,
        schoolCode: user?.schoolCode,
        numOfCandidates: parseInt(details?.productQuantity),
        // rowId: user?.id,
      };
      const response = await axios.post(examCodeUrl, body, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (response?.data?.status === "success") {
        // console.log(response);
        // console.log("got here");
        window.history.back();
        dispatch(
          showModal({
            content: (
              <ConfirmationReceipt
                {...response}
                tx_ref={details?.billNumber}
                name={details?.payerName}
                // examCode={response?.data?.data?.details?.examCode}
                examType={details?.examType}
                price={details?.priceWithCharge}
                // email={user?.email}
                noOfCandidates={details?.productQuantity}
              />
            ),
          }),
        );
        // navigate('/')
      }
    } catch (err) {
      Swal.fire({
        title: "Error",
        text: `Unable to generate Exam Code. Something went wrong`,
        icon: "error",
        confirmButtonText: "Ok",
      });
    } finally {
      setCodeLoading(false);
    }
  };

  const savePlatformTransactionDetails = async () => {
    const body = {
      billNumber: details.billNumber,
      fullName: details?.payerName,
      amount: details.price,
      payerId: details.payerId,
      email: details?.email,
      trxRef: details?.billNumber,
    };

    // console.log(body);

    try {
      const res = await axios.post(`${API}auth/transactions/create`, body, {
        headers: { Authorization: `Bearer ${token}` },
      });
      // console.log(res);
    } catch (error) {
      // console.log(error);
    }
  };

  const configPay = {
    ref: details?.billNumber,
    email: details?.email,
    amount: details.priceWithCharge * 100, //Amount is in the country's lowest currency. E.g Kobo, so 20000 kobo = N200
    publicKey: "pk_test_5c8c7c0d33c73c0f1c67badcfaa3f6a09bbcdfd1",
    text: details.paymentExamType,
    channels: ["card", "bank", "ussd", "qr", "mobile_money", "bank_transfer"],
  };

  // const paystackVerification = async (reference) => {
  //   // const tx_ref = Date.now()
  //   const paystackToken = "pk_test_5c8c7c0d33c73c0f1c67badcfaa3f6a09bbcdfd1";

  //   try {
  //     const res = await axios.get(
  //       `https://api.paystack.co/transaction/verify/${reference}`,
  //       {
  //         headers: {
  //           Authorization: `${paystackToken}`,
  //           "Access-Control-Allow-Origin": "*",
  //           "Content-Type": "application/json",
  //           "Access-Control-Allow-Methods": "GET,POST,OPTIONS,DELETE,PUT",
  //         },
  //       }
  //     );
  //     // console.log(res)
  //     return { data: res.data, status: "successfull" };
  //   } catch (error) {
  //     // console.log(error)
  //     return { data: error.response, status: "error" };
  //   }
  // };

  // const verifyForCode = async (ref) => {
  //   try {
  //     const verifyRes = await paystackVerification(ref);
  //     // console.log("got here too");
  //     // console.log(verifyRes);
  //     if (verifyRes === "successfull") {
  //       dispatch(closeModal({ content: <></> }));
  //       generateCode();
  //       // dispatch(showModal({ content: <Receipt {...response} description={description} price={paymentType === 'Full' ? priceInt : priceInt * .81} email={user.email} paymentType={paymentType} /> }))
  //       // navigate('/')
  //       console.log("TRANSACTION VERIFIED");
  //     } else {
  //       console.log("got here too");
  //       toast.error("An error occured while trying to verify your transaction");
  //     }
  //   } catch (error) {
  //     console.log(error);
  //   }
  // };

  // const handlePaystackPayment = usePaystackPayment(configPay);
  // const paystackPay = async () => {
  //   handlePaystackPayment(
  //     (response) => {
  //       // console.log(response);
  //       if (response.status === "success") {
  //         savePlatformTransactionDetails();
  //         dispatch(closeModal({ content: <></> }));
  //         if (
  //           details.paymentExamType === "BECE" ||
  //           details.paymentExamType === "CAS/Placement" ||
  //           details.examType === "MODEL SCREENING EXAMINATION" ||
  //           details.examType === "PUBLIC SERVICE EXAMINATION"
  //         ) {
  //           toast.success(`${details.paymentExamType} payment successful`);
  //           // generateCode();
  //           window.history.back();
  //           dispatch(
  //             showModal({
  //               content: (
  //                 <ConfirmationReceipt
  //                   {...response}
  //                   tx_ref={details?.billNumber}
  //                   name={details?.payerName}
  //                   // examCode={response?.data?.data?.details?.examCode}
  //                   examName={details?.paymentExamType}
  //                   price={details?.priceWithCharge}
  //                   // email={user?.email}
  //                   noOfCandidates={details?.productQuantity}
  //                 />
  //               ),
  //             })
  //           );
  //         } else {
  //           toast.success(`${details.paymentExamType} payment successful`);
  //         }
  //       } else {
  //         toast.error("An error occured with your payment");
  //       }
  //       // closePaymentModal() // this will close the modal programmatically
  //     },

  //     () => { }
  //   );
  // };

  // const flutterConfig = {
  //   public_key: "FLWPUBK-a42141e0b6041a232d427601a089f71d-X",
  //   tx_ref: details?.billNumber,
  //   amount: details.priceWithCharge,
  //   currency: "NGN",
  //   payment_options: "card,mobilemoney,ussd, banktransfer",
  //   customer: {
  //     email: user?.email,
  //     phone_number: "08148603453",
  //     name: details?.payerName,
  //   },
  //   subaccounts: [
  //     {
  //       id: "RS_2449D8BA3779E2FDE6841BBD9B0ED105",
  //       transaction_charge_type: "percentage",
  //       transaction_charge: 0.01,
  //     }
  //   ],
  //   customizations: {
  //     title: `LASG ExamBoard Payment`,
  //     logo: "/assets/images/laags.png",
  //   },
  // };

  // const flutterwaveVerification = async () => {
  //   // const tx_ref = Date.now()
  //   const flutterToken = "FLWPUBK-a42141e0b6041a232d427601a089f71d-X";

  //   try {
  //     const res = await axios.get(
  //       `https://api.flutterwave.com/v3/transactions/verify_by_reference?tx_ref=${details?.billNumber}`,
  //       {
  //         headers: {
  //           Authorization: `${flutterToken}`,
  //           "Access-Control-Allow-Origin": "*",
  //           "Content-Type": "application/json",
  //           "Access-Control-Allow-Methods": "GET,POST,OPTIONS,DELETE,PUT",
  //         },
  //       }
  //     );
  //     // console.log(res)
  //     return { data: res.data, status: "successfull" };
  //   } catch (error) {
  //     // console.log(error)
  //     return { data: error.response, status: "error" };
  //   }
  // };

  // const handleFlutterPayment = useFlutterwave(flutterConfig);

  // const flutterPay = () => {
  //   handleFlutterPayment({
  //     callback: async (response) => {
  //       // setLoading(true)
  //       console.log(response)
  //       if (response?.status === "completed") {
  //         // toast.success('Payment successful')
  //         // flutterwaveVerification()
  //         savePlatformTransactionDetails();
  //         console.log(response);
  //         dispatch(closeModal());
  //         if (
  //           details.paymentExamType === "BECE" ||
  //           details.paymentExamType === "CAS/Placement" ||
  //           details.paymentExamType === "MODEL SCREENING EXAMINATION" ||
  //           details.paymentExamType === "Public Service"
  //         ) {
  //           toast.success(`${details.paymentExamType} payment successful`);
  //           // generateCode()
  //           dispatch(
  //             showModal({
  //               content: (
  //                 <ConfirmationReceipt
  //                   {...response}
  //                   tx_ref={details?.billNumber}
  //                   name={details?.payerName}
  //                   // examCode={response?.data?.data?.details?.examCode}
  //                   examName={details?.paymentExamType}
  //                   price={details?.priceWithCharge}
  //                   // email={user?.email}
  //                   noOfCandidates={details?.productQuantity}
  //                 />
  //               ),
  //             })
  //           );
  //         } else {
  //           toast.success(`${details.paymentExamType} payment successful`);
  //         }

  //         // const { status } = await flutterwaveVerification(response.tx_ref)
  //         // if (status === 'successfull') {
  //         //     // dispatch(showModal({ content: <Receipt {...response} description={description} price={paymentType === 'Full' ? priceInt : priceInt * .81} email={user.email} paymentType={paymentType} /> }))
  //         //     // navigate('/')
  //         //     console.log('TRANSACTION VERIFIED')
  //         // } else {
  //         //     console.log('got here too')
  //         //     toast.error('An error occured while trying to verify your transaction')
  //         // }
  //       } else {
  //         toast.error(
  //           "An error occured with your payment. Can't generate Unique Exam code if payment is not successful"
  //         );
  //       }
  //       closePaymentModal(); // this will close the modal programmatically
  //     },
  //     onClose: () => {
  //       // generateCode()
  //       // dispatch(closeModal({ content: <></> }))
  //     },
  //   });
  // };

  // const SquadPay = async () => {
  //   const squad_origin = "https://api-d.squadco.com";
  //   const squadToken =
  //     "sk_d77026ca0312a098ec2e944b0493cb3aad30e104";

  //   const habariPayConfig = {
  //     email: details?.email, // from HTML form
  //     amount: details.priceWithCharge * 100, // no need to multiply by 100 for kobo, its taken care for you
  //     currency: "NGN",
  //     initiate_type: "inline",
  //     payment_channels: ['card', 'bank', 'ussd', 'transfer'],
  //     customer_name: details?.payerName,
  //     pass_charge: true,
  //     callback_url: `${window.location.origin}/invoice`,
  //     // transaction_ref: details?.billNumber,
  //   };
  //   try {
  //     setSquadLoading(true);
  //     const res = await axios.post(
  //       `${squad_origin}/transaction/initiate`,
  //       habariPayConfig,
  //       {
  //         headers: { Authorization: ` ${squadToken}` },
  //       }
  //     );
  //     console.log(res);
  //     if ((res.status = 200)) {
  //       console.log(res.data.data.checkout_url);
  //       window.location.assign(res.data.data.checkout_url);
  //     }
  //   } catch (err) {
  //     console.log(err);
  //   } finally {
  //     setSquadLoading(false);
  //   }
  // };

  const notifyUser = () => {
    dispatch(
      showModal({
        content: (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              flexDirection: "column",
            }}
          >
            <Box
              sx={{
                marginTop: "5px",
                flexDirection: "row",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                gap: "20px",
              }}
            >
              <FormButton
                width="medium"
                color="#0B8080"
                onClick={() => {
                  window.open(
                    `https://usepay4it.com/payment/collection?tx_reference=${details?.billNumber}&callbackUrl=${pay4ItCallbackUrl}`,
                    "_blank",
                    "noopener,noreferrer",
                  );
                  details?.paymentExamType === "BECE"
                    ? navigate(`/requisition/bece?tab=payment-details`)
                    : details?.paymentExamType === "CAS/Placement"
                      ? navigate(`/requisition/junior?tab=payment-details`)
                      : details?.paymentExamType === "Public Service"
                        ? navigate(`/requisition/public?tab=payment-details`)
                        : navigate(`/requisition/model?tab=payment-details`);
                  // pay4ItCallbackUrl
                  dispatch(
                    showModal({
                      content: (
                        <ConfirmationReceipt
                          // {...response}
                          tx_ref={details?.billNumber}
                          name={details?.payerName}
                          // // examCode={response?.data?.data?.details?.examCode}
                          // examName={details?.paymentExamType}
                          price={details?.price}
                          // // email={user?.email}
                          // noOfCandidates={details?.productQuantity}
                        />
                      ),
                    }),
                  );
                }}
                label={"Proceed with Payment"}
              />
            </Box>
          </div>
        ),
      }),
    );
  };

  return (
    <>
      <Box borderRadius={"10px"}>
        <Typography
          id="modal-modal-title"
          sx={{
            mt: 0,
            mb: 1,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            fontSize: "30px",
            fontWeight: "800",
          }}
        >
          Payment for {details.paymentExamType} Exam
        </Typography>
        <Divider />
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexWrap: "wrap",
          }}
        >
          <Typography
            weight="600"
            sx={{
              marginTop: "5px",
              width: { xs: "100%", md: "90%" },
              fontSize: "20px",
              display: "flex",
              justifyContent: "center",
              textAlign: "center",
            }}
          >
            Choose your preferred payment platform below and get a unique exam
            code after payment
          </Typography>
        </Box>
        <Box
          sx={{
            display: "flex",
            justifyContent: "start",
            alignItems: "start",
            marginTop: "15px",
            pl: 5,
          }}
        >
          <Typography
            id="modal-modal-description"
            sx={{
              marginTop: "5px",
              display: "flex",
              justifyContent: "flex-start",
              alignItems: "flex-start",
              flexDirection: "column",
              fontSize: "18px",
              fontWeight: "600",
            }}
          >
            <Typography sx={{ fontWeight: "500", fontSize: "18px" }}>
              {" "}
              Amount:{" "}
              <span style={{ fontWeight: "600", fontSize: "18px" }}>
                ₦ {details.price}{" "}
              </span>{" "}
            </Typography>
            <Typography sx={{ fontWeight: "500", fontSize: "18px" }}>
              {" "}
              No of Candidates:{" "}
              <span style={{ fontWeight: "600", fontSize: "20px" }}>
                {details.productQuantity}
              </span>{" "}
            </Typography>
            <Typography sx={{ fontWeight: "500", fontSize: "18px" }}>
              Exam Type:{" "}
              <span style={{ fontWeight: "600", fontSize: "18px" }}>
                {details.paymentExamType}
              </span>{" "}
            </Typography>
          </Typography>
        </Box>
        <div
          style={{
            display: "flex",
            gap: "20px",
            marginBottom: "10px",
            marginTop: "20px",
            justifyContent: "center",
            alignItems: "stretch",
          }}
        >
          <Box
            sx={{
              flexDirection: "row",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              gap: "20px",
            }}
          >
            {/* <FormButton
              width="medium"
              color="#0B8080"
              onClick={() => paystackPay()}
              label={
                paystackLoading ? <Spinner width="5%" /> : "Pay With Paystack"
              }
            /> */}
            {/* <FormButton
              width="medium"
              color="#0B8080"
              onClick={() => flutterPay()}
              label={
                flutterloading ? <Spinner width="5%" /> : "Pay With Flutterwave"
              }
            /> */}

            <FormButton
              width="medium"
              color="#0B8080"
              onClick={() =>
                window.open(
                  `https://usepay4it.com/payment/collection?tx_reference=${details?.billNumber}&callbackUrl=${pay4ItCallbackUrl}`,
                  "_self",
                )
              }
              // onClick={() => window.open(`https://usepay4it.com/payment/collection?tx_reference=${details?.price}&callbackUrl=${pay4ItCallbackUrl}`, "_self")}
              label={"Pay With Pay4it"}
            />
            {/* <FormButton
              width="medium"
              color="#0B8080"
              onClick={() => SquadPay()}
              label={
                squadloading ? <Spinner width="5%" /> : "Pay With GT Squad Pay"
              }
            /> */}
          </Box>
        </div>
      </Box>
    </>
  );
};

export default PaymentModal;
